import Control from '../Control.js';

class InfoDisplay extends Control {
    getInfoContainer() {
        return null;
    }
}

export default InfoDisplay;